import React, { Component } from "react";
import ButtonTheme from "css/themes/Buttons.css";
import DialogTheme from "css/themes/dialogs/formModal.css";
import EventTrackingDispatcher from "dispatchers/event-tracking-dispatcher";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Dialog from "react-toolbox/lib/dialog";
import ModalButtonGroup from "visual-components/util/buttons/ModalButtonGroup";

const themes = {
  Button: ButtonTheme,
  Dialog: DialogTheme,
};

const mapState = (state) => {
  return {
    pricingModal: state.pricingModal,
  };
};

class PricingGateModal extends Component {
  closeModal = () => {
    if (!this.props.pricingModal.noAccess) {
      store.dispatch({
        type: "UPDATE_ATTR",
        model: "pricingModal",
        data: {
          expand: false,
        },
      });
    }
  };

  upgradePlan = () => {
    const {
      history,
      pricingModal: { feature, eventTrack },
    } = this.props;

    if (eventTrack === "messageUpgrade") {
      EventTrackingDispatcher.track("app_upgrade_upgradeButton_messageUpgradeModal");
    } else if (eventTrack === "hostUpgrade") {
      EventTrackingDispatcher.track("app_upgrade_upgradeButton_hostUpgradeModal");
    }

    store.dispatch({
      type: "UPDATE_ARR",
      model: "general",
      data: {
        upgradeFeature: feature,
        upgradeOriginalLocation: history.location.pathname,
      },
    });

    history.push("/upgrade-plan");
    this.closeModal();
  };

  render() {
    const { pricingModal } = this.props;
    const hideConfirmButton = pricingModal.hideConfirmButton ?? false;

    return (
      <Dialog
        theme={themes.Dialog}
        active={!!pricingModal.expand}
        onEscKeyDown={this.closeModal}
        onOverlayClick={this.closeModal}
        title={pricingModal.title}
      >
        {!pricingModal.noAccess ? (
          <img
            onClick={this.closeModal}
            className={themes.Dialog.closeImage}
            src="/images/icons/close.svg"
          />
        ) : null}

        <img
          src="/images/nav-bar/mojo-white-tiger-logo.svg"
          style={{
            width: "126px",
            height: "120px",
            marginBottom: "24px",
            marginLeft: "241px",
          }}
        />

        <p
          style={{
            fontFamily: "Larsseit-Light",
            fontSize: "16px",
            lineHeight: "24px",
            color: "#212731",
            marginBottom: "16px",
          }}
        >
          {pricingModal.message}
        </p>

        <ModalButtonGroup
          cancel={!pricingModal.noAccess ? this.closeModal : false}
          cancelText={hideConfirmButton ? "Ok" : "No, Thanks"}
          hideLine
          {...(!hideConfirmButton && {
            confirm: this.upgradePlan,
            confirmText: "View Upgrade Options",
            canSave: true,
          })}
        />
      </Dialog>
    );
  }
}

export default withRouter(connect(mapState)(PricingGateModal));
